import React from 'react';
import styled from 'styled-components';
import Icon from './icons';
import { BiChevronsLeft, BiChevronsRight } from 'react-icons/bi';

const TutorialContainer = styled.div`
  margin-top: -20px;
  opacity: 0.2;
  display: flex;
  justify-content: center;
  position: relative;
  animation: left_right 1s infinite;
  @keyframes left_right {
    0% {
      left: 0px;
    }
    50% {
      left: 50px;
    }
    100% {
      left: 0px;
    }
  }
`;

const IconWrapper = styled.div`
  width: 40px;
  height: 40px;
  text-align: center;
  svg {
    fill: var(--color-text);
  }
`;
export default function Tutorial({ toShow }) {
  return toShow ? (
    <TutorialContainer>
      <IconWrapper>
        <BiChevronsLeft size={30} />
      </IconWrapper>
      <IconWrapper>
        <Icon iconName="hand" />
      </IconWrapper>
      <IconWrapper>
        <BiChevronsRight size={30} />
      </IconWrapper>
    </TutorialContainer>
  ) : (
    <></>
  );
}
